import React from 'react';
import './App.scss';
import Timesheet from './pages/Timesheet';

const App = (): JSX.Element => (
  <div className="timesheet-wrapper">
    <Timesheet />
  </div>
);

export default App;
